import { Link } from '@servicetitan/design-system';
import { FC, MouseEvent, ReactNode } from 'react';
import { useDownloadCurrentTerms } from './use-download-current-terms';

interface TermsOfServiceLinkProps {
    className?: string;
    primary?: boolean;
    subdued?: boolean;
    children?: ReactNode;
}

export const TermsOfServiceLink: FC<TermsOfServiceLinkProps> = ({
    children = 'Terms of Service',
    className,
    primary,
    subdued,
}) => {
    const downloadCurrentTerms = useDownloadCurrentTerms();

    const onClick = (e: MouseEvent) => {
        e.preventDefault();
        downloadCurrentTerms();
    };

    return (
        <Link
            type="button"
            onClick={onClick}
            className={className}
            primary={primary}
            subdued={subdued}
        >
            {children}
        </Link>
    );
};
